if (!customElements.get('what-fits-section')) {
  customElements.define(
    'what-fits-section',
    class WhatFitsSection extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-what-fits-tab]');
        this.tabsEl = this.querySelector('[data-what-fits-tabs]');
        this.images = this.querySelectorAll('[data-what-fits-image]');
        this.sliderEl = this.querySelector('[data-what-fits-slider]');
        this.imagesSliderEl = this.querySelector('[data-what-fits-images-slider]');
        this.activeIndex = 0;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
        });

        this.onResize = () => this.initSlider();
        window.addEventListener('resize', this.onResize);
        this.initSlider();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.destroySlider();
      }

      get isMobile() {
        return window.innerWidth < 1024;
      }

      // Mobile: moves the slider, whose snap change then marks the tab. Desktop: crossfades the image.
      selectTab(index) {
        if (this.imagesSwiper) {
          this.imagesSwiper.slideTo(index);
        } else {
          this.setActive(index);
        }
      }

      setActive(index) {
        if (index === this.activeIndex) return;
        this.activeIndex = index;

        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          if (isActive) {
            tab.setAttribute('aria-current', 'true');
          } else {
            tab.removeAttribute('aria-current');
          }
        });
        this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
        this.scrollTabIntoView(this.tabs[index]);
      }

      // Keeps the active tab visible when the tab row overflows on mobile; scrolls only the row, never the page.
      scrollTabIntoView(tab) {
        if (!tab || !this.tabsEl || this.tabsEl.scrollWidth <= this.tabsEl.clientWidth) return;
        const left = tab.offsetLeft - (this.tabsEl.clientWidth - tab.offsetWidth) / 2;
        this.tabsEl.scrollTo({ left, behavior: 'smooth' });
      }

      destroySlider() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        if (this.imagesSwiper) {
          this.imagesSwiper.destroy(true, true);
          this.imagesSwiper = null;
        }
      }

      initSlider() {
        if (!this.sliderEl || typeof Swiper === 'undefined') return;
        if (this.sliderIsMobile === this.isMobile) return;

        this.sliderIsMobile = this.isMobile;
        this.destroySlider();
        if (!this.sliderIsMobile) return;

        // With a fractional slides per view the last slide never becomes Swiper's activeIndex (the slider stops
        // before it reaches the left edge), so tabs follow snapIndex, which has one snap per slide.
        const syncTab = (swiper) => this.setActive(swiper.snapIndex);
        const sliderOptions = {
          slidesPerView: 1.15,
          spaceBetween: 0,
          watchOverflow: true,
          initialSlide: this.activeIndex,
          on: { snapIndexChange: syncTab },
        };

        this.swiper = new Swiper(this.sliderEl, {
          ...sliderOptions,
          pagination: {
            el: this.sliderEl.querySelector('[data-what-fits-progress]'),
            type: 'progressbar',
          },
        });

        if (!this.imagesSliderEl) return;

        this.imagesSwiper = new Swiper(this.imagesSliderEl, sliderOptions);

        // Swiping either the images or the text moves the other one along with it
        this.imagesSwiper.controller.control = this.swiper;
        this.swiper.controller.control = this.imagesSwiper;
      }
    },
  );
}
